import { useId } from 'react';

import { usePlatformDeleteReport } from '@cloudquery/api-platform';
import { useBaseAuthenticated } from '@cloudquery/base-users';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import { CloseButton } from 'shared/base';

interface Props {
  onClose: () => void;
  open: boolean;
  reportId: string;
}

export function DeleteReportDialog({ onClose, open, reportId }: Props) {
  const labelId = useId();
  const { currentMembership } = useBaseAuthenticated();
  const { mutateAsync: deleteReport } = usePlatformDeleteReport();

  const handleDeleteReport = async () => {
    await deleteReport({ reportId, teamName: currentMembership.team.name });
    onClose();
  };

  return (
    <Dialog
      aria-labelledby={labelId}
      fullWidth={true}
      onClose={onClose}
      open={open}
      slotProps={{
        paper: {
          sx: {
            bgcolor: 'background.paper',
            maxWidth: '400px',
            width: '100%',
          },
        },
      }}
    >
      <DialogTitle id={labelId} sx={{ paddingBottom: 0, paddingTop: 4 }}>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <Typography variant="h6">Delete report?</Typography>
          <CloseButton onClose={onClose} />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete this report? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} size="medium" variant="outlined">
          Cancel
        </Button>
        <Button color="error" onClick={handleDeleteReport} size="medium" variant="contained">
          Delete report
        </Button>
      </DialogActions>
    </Dialog>
  );
}
